import React from "react";
import { withRouter } from "react-router-dom";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import Link from "../../../../core/Components/Link";

const SubHeaderWithLink = ({ fields, location }) => {
  const params = new URLSearchParams(location.search);
  const showModelContent = fields.isDevicePage.value && params.has("device-id");

  const title = showModelContent ? fields.modelTitle : fields.title;
  const link = showModelContent ? fields.modelLink : fields.link;

  return (
    <div className="sub-header">
      <Text className="sub-header-title" field={title} tag="h1" />
      {link.value.href ? (
        <Link
          className={`sub-header-link${
            link.value.target === "_blank" ? " external" : ""
          }`}
          field={link}
        />
      ) : null}
    </div>
  );
};

export default withRouter(SubHeaderWithLink);
